import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import ExitedFilter from '../RefineSearchComponents/ExitedFilter';
import InvestorCityTag from '../RefineSearchComponents/InvestorCityTag';
import FollowExitStatusFilter from '../RefineSearchComponents/InvestorStatusFilter';
import DateFounded from '../RefineSearchComponents/DateFounded'
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import { filterSectorByIndutry, tagList } from "../../Config/config";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import { Tooltip } from "antd";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
/**
 * The InvestmentRefineSearch function is a React component that renders a form for refining search
 * filters for investment data.
 * @returns The function `InvestmentRefineSearch` is returning a JSX element.
 */

export default function InvestmentRefineSearch({ customPathname, haveTopCard = true, generalPathname }) {
    const {
        setSectors,Sectors,SwitchState,setSwitchState,dropdown,dbDropdown , setDbDropdown ,
        angelInvestorOptions, setAngelInvestorOptions, TargetCompanyOptions , setTargetCompanyOptions ,lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions,
        onErrorHandler, setrefineSearchFilters, setMonthPickerValue ,refineSearchFilters, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false
 console.log(refineSearchFilters[pathname]?.globalSearch,"refineSearchFilters[pathname]?.globalSearch");
    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [ExitedOptions, setExitedOptions] = useState([])
    const [FollowExitStatusOptions, setFollowExitStatusOptions] = useState([])
    const [FromDateOption, setFromDateOption] = useState();
    const [ToDateOption, setToDateOption] = useState()
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    
    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getInvestorFiltersCount = () => {
        let count = 0;
        if (FirmTypeOptions?.length > 0 && FirmTypeOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getCompanyFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions?.length > 0 && IndustriesOptions.some(option => option.isChecked)) count++;
        if (SectorOptions?.length > 0 && SectorOptions.some(option => option.isChecked)) count++;
        if (ExitedOptions?.length > 0 && ExitedOptions.some(option => option.isChecked)) count++;
        if (FollowExitStatusOptions?.length > 0 && FollowExitStatusOptions.some(option => option.isChecked)) count++;
        if (FromDateOption || ToDateOption) count++;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (TagsOptions.length > 0) count++;
        if (angelInvestorOptions?.length > 0 && angelInvestorOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.length > 0 && TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.length > 0 && tAdvisorsOptions.some(option => option.isChecked)) count++;
        return count;
    };

  /**
   * The function `applyFilter` updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedExited = ExitedOptions?.filter(option => option.isChecked);
        const selectedStatus = FollowExitStatusOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = angelInvestorOptions?.filter(option => option.isChecked); 
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        setMonthPickerValue([FromDateOption, ToDateOption])

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                city: selectedCity,
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                target_company:selectedTargetCompany,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
            },
            [customPathname]: {
                ...prev[customPathname],
                investor_id : selectedInvestor,
                exited: selectedExited,
                firmType: selectedFirm,
                followexitStatus: selectedStatus,
            },
        }))
    }

    useEffect(()=> {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                investorType: [],
                firmType:[],
                firm_Sub_type:[],
            }
        }))
    }, [])
    
  /**
   * The function `resetFilter` resets the refine search filters and month picker value.
   */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setAngelInvestorOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setSectors([]);
        setMonthPickerValue(Constants.initialMonthRange)
    }



    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets month picker value, applies
    * filters, resets selection, and navigates to a custom pathname.
    * @param event - The `event` parameter is an object that represents the event that triggered the
    * function. It could be an event like a button click or a form submission.
    */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
            },
            [customPathname]: {globalSearch:[],
            }
        }
        ))
        
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

    /**
     * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
     * if it is not already the current location.
     * @param event - The event parameter is an object that represents the event that triggered the
     * function. In this case, it is likely a click event on a reset button.
     */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };


    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])

    const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "includes_secondary_tags": secondaryTagCheck,
            "type"    : type

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        openTagModal(tags, competitorTags, secondaryTags)
    };
    
    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };
    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };
    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Investor</span>
                                        {getInvestorFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getInvestorFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>
                            {/* Right column - Filters */}
                            <div className="overflow-visible md:overflow-auto mt-4 md:mt-0 max-h-[calc(100vh-300px)] md:max-h-none pb-20 md:pb-0 md:col-span-6">
                                {activeFilterSection === 'keyword' && (
                                <div className={`w-full md:w-1/2 relative`}>
                                        <div className="space-y-4">
                                            <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                                <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                    <Tags
                                                        TagsOptions={TagsOptions}
                                                        customPathname={generalPathname}
                                                        setTagsOptions={setTagsOptions}
                                                        getSearchTags={getSearchTags}
                                                    />
                                                    <Switch
                                                        SwitchState={TagSwitchState}
                                                        setSwitchState={setSwitchState}
                                                        customPathname={generalPathname} 
                                                    />
                                                </div>
                                                <div className="md:hidden flex items-center">
                                                    <Tooltip title='Tag List'>
                                                        <FaInfoCircle 
                                                            size={16} 
                                                            color="grey" 
                                                            className="cursor-pointer px-[1px]"
                                                            onClick={fetchData}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                                <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                                <span>include secondary tags</span>
                                            </div>
                                            <Tooltip title='Tag List'>
                                                <FaInfoCircle 
                                                    size={16} 
                                                    color="grey" 
                                                    className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                    onClick={fetchData}
                                                />
                                            </Tooltip>
                                        </div>
                                        <div className="mt-4 space-y-4">
                                            <Investor 
                                                options={angelInvestorOptions}
                                                setOptions={setAngelInvestorOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(32)}
                                                label="Investor"
                                                open={select === 32}
                                            />
                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(31)}
                                                label="Company"
                                                open={select === 31}
                                            />
                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={generalPathname}
                                                label="Legal Advisors"
                                                accordionClick={() => accordionClick(21)}
                                                open={select === 21}
                                            />
                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(29)}
                                                open={select === 29}
                                            />
                                        </div>
                                    </div>
                                )}
                                
                                {activeFilterSection === 'company' && (
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-8 md:gap-y-8 overflow-visible`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                        />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={generalPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                        />
                                        <ExitedFilter
                                            ExitedOptions={ExitedOptions}
                                            setExitedOptions={setExitedOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'exited'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exited' : null)}
                                        />
                                        <FollowExitStatusFilter
                                            FollowExitStatusOptions={FollowExitStatusOptions}
                                            setFollowExitStatusOptions={setFollowExitStatusOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'followExitStatus'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'followExitStatus' : null)}
                                        />
                                        <DateFounded
                                            FromDateOption={FromDateOption}
                                            setFromDateOption={setFromDateOption}
                                            ToDateOption={ToDateOption}
                                            setToDateOption={setToDateOption}
                                            isPopupOpen={openFilterPopup === 'dateFounded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dateFounded' : null)}
                                        />
                                        <InvestorCityTag
                                            CityOptions={CityOptions}
                                            customPathname={generalPathname}
                                            setCityOptions={setCityOptions}
                                            accordionClick={() => accordionClick(20)}
                                            open={select === 20}
                                            isPopupOpen={openFilterPopup === 'investorCity'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorCity' : null)}
                                        />
                                    </div>
                                )}
                                
                                {activeFilterSection === 'investor' && (
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-8 md:gap-y-8`}>
                                        <FirmTypeFilter
                                            FirmTypeOptions={FirmTypeOptions}
                                            setFirmTypeOptions={setFirmTypeOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(16)}
                                            dataPath="angel"
                                            open={select === 16}
                                            isPopupOpen={openFilterPopup === 'firmType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                        />
                                        
                                    </div>
                                )}
                                
                                {!activeFilterSection && (
                                <div className={`flex items-center justify-center h-40 text-gray-500`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    );
}
